import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComponentListComponent } from './components/component/component-list/component-list.component';
import { ConfigurationDetailsComponent } from './components/configuration/configuration-details/configuration-details.component';
import { ConfigurationListComponent } from './components/configuration/configuration-list/configuration-list.component';
import { LoginComponent } from './components/login/login.component';
import { ManageBikesComponent } from './components/manage-bikes/manage-bikes.component';
import { ReleaseDetailsComponent } from './components/release/release-details/release-details.component';
import { ReleaseOverviewComponent } from './components/release/release-overview/release-overview.component';
import { BikeDetailsComponent } from './components/manage-bikes/bike-details/bike-details.component';
import { BrowserUtils } from '@azure/msal-browser';
import { MsalGuard } from '@azure/msal-angular';
import { RecalledListComponent } from './components/component/recalled-list/recalled-list.component';
import { RecalledUploadComponent } from './components/component/recalled-upload/recalled-upload.component';
import { UserRoleGuard } from './guards/user-role.guard';
import { UnassignedBikesComponent } from './components/unassigned-bikes/unassigned-bikes.component';
import { StartApprovalRolloutComponent } from './components/rollout/start-approval-rollout/start-approval-rollout.component';
import { StartRolloutComponent } from './components/rollout/start-rollout/start-rollout.component';
import { MonitorSoftwareComponent } from './components/rollout/monitor-software/monitor-software.component';
import { UnsavedChangesGuard } from './guards/unsaved-changes.guard';
import { AddSubComponentComponent } from './components/component/add-sub-component/add-sub-component.component';

/** 
 * Checks user token before loading route.
 */
const mainResolver = {
}

const routes: Routes = [
  //{path: '', canActivate: [MsalGuard]}
  /** Login */
  { path: "login", component: LoginComponent, canActivate: [MsalGuard, UserRoleGuard] },
  { path: "permission-error", component: LoginComponent, canActivate: [MsalGuard, UserRoleGuard] },

  /** Release paths */
  { path: "software-overview", component: ReleaseOverviewComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard] },
  {
    path: "new-software", component: ReleaseDetailsComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard],
    canDeactivate: [UnsavedChangesGuard]
  },
  { path: "view-software", component: ReleaseDetailsComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard],
    canDeactivate: [UnsavedChangesGuard]
   },
  {
    path: "edit-software", component: ReleaseDetailsComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: "start-approval-rollout", component: StartApprovalRolloutComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: "start-rollout", component: StartRolloutComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard],
    canDeactivate: [UnsavedChangesGuard]
  },
  { path: "monitor-software", component: MonitorSoftwareComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard] },

  { path: "software-bikes-details", component: ManageBikesComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard] },
  { path: "software-deliveries-details", component: ManageBikesComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard] },
  { path: "software-success-details", component: ManageBikesComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard] },
  { path: "software-errors-details", component: ManageBikesComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard] },

  /** Modify components paths */
  { path: "components", component: ComponentListComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard] },
  { path: "component-variant", component: AddSubComponentComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard] },

  /** Mark components paths */
  { path: "recalled-components", component: RecalledListComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard] },
  { path: "recalled-upload", component: RecalledUploadComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard] },

  /** Inventory paths */
  { path: "bike-overview", component: ManageBikesComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard] },
  {
    path: "bike-details", component: BikeDetailsComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard],
    canDeactivate: [UnsavedChangesGuard]
  },

  /** Configuration management paths */
  { path: "configurations", component: ConfigurationListComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard] },
  {
    path: "new-configuration", component: ConfigurationDetailsComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: "view-configuration", component: ConfigurationDetailsComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard]
  },
  {
    path: "edit-configuration", component: ConfigurationDetailsComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard],
    canDeactivate: [UnsavedChangesGuard]
  },

  /** Unassigned bikes paths */
  { path: "unassigned-bikes", component: UnassignedBikesComponent, resolve: mainResolver, canActivate: [MsalGuard, UserRoleGuard] },

  { path: "**", redirectTo: "/software-overview", pathMatch: "full" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? "enabledNonBlocking" : "disabled"
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
